import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ModalToCompleteProfile = {
  openModalToCompleteProfile: boolean;
  setOpenModalToCompleteProfile: (type: boolean) => void;
};

const useModalToCompleteProfile = create(
  persist<ModalToCompleteProfile>(
    set =>
      ({
        openModalToCompleteProfile: false,
        setOpenModalToCompleteProfile: (type: boolean) =>
          set({ openModalToCompleteProfile: type }),
      } as ModalToCompleteProfile),
    {
      name: '@tenGovUseModalToCompleteProfile',
    },
  ),
);

export default useModalToCompleteProfile;
